(function () {
    if (window.faqSectionInitialized) return;
    window.faqSectionInitialized = true;

    function initializeFAQSection() {
        const faqSections = document.querySelectorAll('.faq-section');

        faqSections.forEach(section => {
            if (section.dataset.faqInitialized) return;
            section.dataset.faqInitialized = 'true';

            const faqItems = section.querySelectorAll('.faq-item');

            function toggleFAQItem(faqItem, forceClose = false) {
                const questionButton = faqItem.querySelector('[data-faq-toggle]');
                const answer = faqItem.querySelector('.faq-item__answer');
                
                if (!questionButton || !answer) return;

                const isExpanded = questionButton.getAttribute('aria-expanded') === 'true';
                const shouldClose = forceClose || isExpanded;

                // Accordion behavior: Close all other items first
                if (!shouldClose) {
                    faqItems.forEach(otherItem => {
                        if (otherItem !== faqItem) {
                            toggleFAQItem(otherItem, true);
                        }
                    });
                }

                questionButton.setAttribute('aria-expanded', !shouldClose);
                answer.setAttribute('aria-hidden', shouldClose);

                if (!shouldClose) {
                    questionButton.classList.add('faq-item__question--active');
                    answer.classList.add('faq-item__answer--active');
                    faqItem.classList.add('faq-item--active');
                } else {
                    questionButton.classList.remove('faq-item__question--active');
                    answer.classList.remove('faq-item__answer--active');
                    faqItem.classList.remove('faq-item--active');
                }
            }

            faqItems.forEach(faqItem => {
                // Click event
                faqItem.addEventListener('click', function (e) {
                    e.preventDefault();
                    toggleFAQItem(this);
                });

                // Keyboard navigation
                faqItem.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleFAQItem(this);
                    }
                });

                // Make focusable for keyboard navigation
                if (!faqItem.hasAttribute('tabindex')) {
                    faqItem.setAttribute('tabindex', '0');
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeFAQSection);
    } else {
        initializeFAQSection();
    }

    // Allow re-initialization after the PDP blend/honey switcher swaps the FAQ
    // section's markup via AJAX. The freshly injected .faq-section has no
    // data-faqInitialized flag yet, so this binds listeners on the new items.
    window.initFAQSection = initializeFAQSection;
    document.addEventListener('pdp:aux-sections-updated', initializeFAQSection);
})();